


















import { Component, Prop, mixins } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
@Component
export default class componentBadge extends mixins(MixinGeneral) {
  @Prop({ default: null, type: [String, Number] }) readonly content!: null
  @Prop({ default: 'secondary', type: String }) readonly color!: string
  @Prop({ default: false, type: Boolean }) readonly circle!: boolean

  private get colorType() {
    return {
      [this.$style.primary]: this.color === 'primary',
      [this.$style.secondary]: this.color === 'secondary',
    }
  }
}
